import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  error: null,
  emailData: null,
  success: false,
};

const shareReportSlice = createSlice({
  name: "shareReport",
  initialState,
  reducers: {
    sendReportEmail: (state, action) => {
      state.loading = true;
      state.error = null;
      state.success = false;
      state.emailData = null;
    },
    sendReportEmailSuccess: (state, action) => {
      state.loading = false;
      state.success = true;
      state.emailData = action.payload?.data || null;
    },
    sendReportEmailFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload?.message || "Failed to send report email";
      state.success = false;
    },
    resetShareReportState: (state) => {
      state.loading = false;
      state.error = null;
      state.emailData = null;
      state.success = false;
    },
  },
});

export const { actions, reducer } = shareReportSlice;
export const sliceKey = shareReportSlice.name;